import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import {
  ApproveClientReportModal,
  RemoveClientReportModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithMetricsLayout } from 'modules/components/layer32';
import React, { useState } from 'react';
import * as ds from './dataService';
import {
  useNavigate,
  useParams
} from 'react-router-dom';



export type ClientReportHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.clientReportId ?? '');
  return (
    <ActivityHeaderSectionWithMetricsLayout.FC
      title='Client Report'
      subtitle='Verify and modify data for the report.'
      metrics={<ClientReportInformationMetric />}
      actionButtons={(
        <ActionButtonsGroup
          id={params.clientReportId ?? ''}
          isApproved={data.isApproved}
        />
      )}
      backButton={<></>}
    />
  );
};


const ClientReportInformationMetric = () => {
  const theme = useTheme();
  return (
    <Box
      display='flex'
      flexDirection='row'
      paddingX='1.25rem'
      paddingY='1.5rem'
      columnGap='1.5rem'
      borderRadius='1.5rem'
      bgcolor={theme.palette.info.light}
    >
      <Stack
        bgcolor='white'
        padding='.75rem'
        borderRadius='.75rem'
      >
        <CustomIcon.large.FC
          icon='INFO'
          stroke={theme.palette.info.main}
        />
      </Stack>
      <Stack
        rowGap='.375rem'
        direction='column'
      >
        <Typography
          variant='bodyBold'
          color={theme.palette.info.main}
        >
          Contents of the client report are attached automatically
        </Typography>
        <Typography
          variant='body1'
          color={theme.palette.info.main}
        >
          All of the deliveries and achieved milestones that happened since last client report are present by default.
        </Typography>


      </Stack>

    </Box>
  );
};



type ActionButtonsGroup = { id: string; isApproved: boolean };

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isDeleteVisible,
    setIsDeleteVisible
  ] = useState(false);

  const navigate = useNavigate();
  return (
    <>
      {isVisible && (
        <ApproveClientReportModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      {isDeleteVisible && (
        <RemoveClientReportModal.FC
          id={props.id}
          isVisible={isDeleteVisible}
          handleClose={() => {
            setIsDeleteVisible(() => false);
            navigate('..');
          }}
        />
      )}
      <Button
        variant='contained'
        color='error'
        disabled={props.isApproved}
        onClick={() => {
          setIsDeleteVisible(() => true);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='DELETE'
            stroke={theme.palette.error.contrastText}
          />
        )}
      >
        Delete
      </Button>
      <Button
        variant='outlined'
        color='primary'
        disabled={props.isApproved}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='CHECKFLAT'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Send to client
      </Button>
    </>
  );
};

